'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadr';
var iconName = 'forklift';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'f47a';
var svgPathData = ['M48 224l0 121.6c12-6.1 25.6-9.6 40-9.6 40.2 0 74.1 27 84.6 63.8 23.6 0 47.1 0 70.7 .2 10.5-37 44.5-64 84.7-64 2.7 0 5.4 .1 8 .4l0-48.4-128 0c-6.4 0-12.5-2.5-17-7l-73-73-54.1 0c-8.8 0-16 7.2-16 16z', 'M496 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 432c0 13.3 10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-56 0 0-408zM48 424a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM0 224L0 424c0 48.6 39.4 88 88 88 40.3 0 74.2-27.1 84.7-64l70.6 0c10.4 36.9 44.4 64 84.7 64 48.6 0 88-39.4 88-88 0-27.3-12.5-51.7-32-67.9l0-90c0-10-2.1-19.9-6.1-29L300.3 60.7C292.6 43.2 275.4 32 256.3 32L144 32c-26.5 0-48 21.5-48 48l0 80-32 0c-35.3 0-64 28.7-64 64zM336 336.4c-2.6-.2-5.3-.4-8-.4-40.3 0-74.2 27.1-84.7 64l-70.6 0c-10.4-36.9-44.4-64-84.7-64-14.4 0-28 3.5-40 9.6L48 224c0-8.8 7.2-16 16-16l54.1 0 73 73c4.5 4.5 10.6 7 17 7l128 0 0 48.4zM326.7 240l-108.8 0-73-73c-.3-.3-.6-.6-1-.9l0-86.1 112.3 0 70.4 160zM288 424a40 40 0 1 1 80 0 40 40 0 1 1 -80 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faForklift = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;